import { DEFAULT_USER_PREFERENCES, type UserPreferences } from "@orsane/schema/users";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { createDateFormatter } from "@/lib/format";
import { useTRPC } from "@/lib/trpc";

/**
 * The signed-in user's display preferences. Prefetched by the app route's loader and only
 * changed by the user themselves (which writes the cache directly), so never refetched.
 * Until it resolves, or if it fails, the defaults apply: they match what the app showed
 * before preferences existed.
 */
export function useUserPreferences(): UserPreferences {
    const trpc = useTRPC();
    const { data } = useQuery(trpc.user.preferences.queryOptions(undefined, { staleTime: Infinity }));
    return data ?? DEFAULT_USER_PREFERENCES;
}

/** Date/time formatting bound to the current user's preferences. */
export function useDateFormatter() {
    const preferences = useUserPreferences();
    return useMemo(() => createDateFormatter(preferences), [preferences]);
}
